/**
 * Created by mongoose on 8/11/17.
 */
import { BASE_URL } from "../../request";
import ModuleTranslations from "./ModuleTranslations";
import { getTranslatedDefinition } from "../utils";
import { tickerValidator } from "../../globalVariables";
import { DISPLAY } from "../../Common/constants";

const ModuleDefinition = {
  name: "Display Configuration",
  entityName: "display",
  restConfig: {
    baseURL: `${BASE_URL}`,
    create: {
      url: ({ propertyTicker }) => `api/properties/${propertyTicker}/displays`,
      method: "post",
      resetCache: true,
    },
    update: {
      url: ({ propertyTicker }) => `api/properties/${propertyTicker}/displays`,
      method: "put",
      resetCache: true,
    },
    fetch: {
      url: ({ propertyTicker, id }) => `/api/properties/${propertyTicker}/displays/${id ? id : ""}`,
      method: "get",
    },
    delete: {
      url: ({ propertyTicker, id }) => `api/properties/${propertyTicker}/displays/${id}`,
      method: "delete",
      resetCache: true,
    },
  },
  renderers: {
    list: {},
    form: {},
  }, //render functions by attribute name, this overrides default widgets specified in the fields section
  translation: {
    translated: true,
    fieldName: "translations",
    displayName: "Traducciones",
    widget: "translations",
    entityProperty: "translations",
  },
  sorting: {
    property: "position",
  },
  reorder: true,
  fields: {
    list: [
      //columns to be used in the table/list display, Order IS important
      {
        fieldName: "active",
        displayName: "is Active",
        widget: "singleSwitch",
        toggleAction: true,
      },
      {
        fieldName: "ticker",
        displayName: "Ticker",
      },
      {
        fieldName: "startDate",
        displayName: "Booking Window Start Date",
      },
      {
        fieldName: "endDate",
        displayName: "Booking Window End Date",
      },
      {
        fieldName: "conditions",
        displayName: "Conditions",
        widget: "displayConditionsRenderer",
      },
      {
        fieldName: "position",
        displayName: "Order",
        sortProperty: true,
      },
    ],
    form: [
      //fields to be used in the creation/edit form display, Order IS important
      {
        fieldName: "id",
        widget: "hidden",
      },
      {
        fieldName: "active",
        displayName: "Is active?",
        widget: "singleSwitch",
        helpText: "Is the display visible on the IBE?",
        defaultValue: false,
      },
      {
        fieldName: "defaultOption",
        displayName: "Opens by default",
        widget: "checkbox",
        defaultValue: false,
      },
      {
        fieldName: "position",
        displayName: "Position",
        widget: "hidden",
      },
      {
        fieldName: "ticker",
        displayName: "Ticker",
        readOnly: true,
        widget: "input",
      },
      {
        fieldName: "propertyTicker",
        displayName: "Property Ticker",
        widget: "hidden",
      },
      {
        fieldName: "type",
        displayName: "Display type",
        widget: "selector",
        optionDisplay: {
          INFO: {
            label: "Info",
          },
          AVAILABILITY: {
            label: "Availability",
          },
          MAP: {
            label: "Map",
          },
          CUSTOM: {
            label: "Custom",
          },
        },
        helpText: "Info / availability and map override the default views",
        defaultValue: "CUSTOM",
        visible: () => false,
      },
      {
        fieldName: "startDate",
        displayName: "Booking window start date",
        widget: "datepicker",
        dateFormat: "YYYY-MM-DD",
        placeholder: "Enter a date",
        isRange: true,
        startField: "startDate",
        endField: "endDate",
        selectsStart: true,
      },
      {
        fieldName: "endDate",
        displayName: "Booking window end date",
        widget: "datepicker",
        dateFormat: "YYYY-MM-DD",
        placeholder: "Enter a date",
        isRange: true,
        startField: "startDate",
        endField: "endDate",
        selectsEnd: true,
      },
      {
        fieldName: "entityFilter",
        displayName: "Show only for:",
        widget: "selector",
        className: "border-none",
        optionDisplay: {
          PROPERTY: {
            label: "Property",
          },
          ACCOMMODATION: {
            label: "Accommodations",
          },
        },
        helpText: "This view will only be visible for elements of this type",
        defaultValue: "PROPERTY",
      },
      {
        fieldName: "tickerFilter",
        displayName: "Show only for the following tickers (comma separated) :",
        widget: "input",
        visible: ({ formValues }) => formValues.entityFilter !== "PROPERTY",
      },
      {
        fieldName: "contentType",
        displayName: "Content type",
        widget: "selector",
        optionDisplay: {
          HTML: {
            label: "HTML",
          },
          VIDEO: {
            label: "Video",
          },
          IMAGE: {
            label: "Image",
          },
        },
        defaultValue: "HTML",
      },
      {
        fieldName: "youTubeURL",
        displayName: "Youtube URL",
        widget: "input",
        visible: ({ formValues }) => formValues.contentType === DISPLAY.VIDEO,
      },
      {
        fieldName: "imageManager",
        widget: "imageManager",
        displayName: "Image",
        visible: ({ formValues }) => formValues.contentType === DISPLAY.IMAGE,
      },
      {
        fieldName: "label",
        displayName: "Label",
        widget: "input",
        translated: true,
      },
      {
        fieldName: "content",
        displayName: "Content",
        widget: "richHTMLEditor",
        dontShowInsertVideo: true,
        translated: true,
      },
    ],
  },
  validation: {
    id: {
      type: "String",
      constraints: {
        presence: {
          allowEmpty: true,
        },
      },
    },
    propertyTicker: {
      type: "String",
      constraints: {
        presence: {
          allowEmpty: false,
        },
      },
    },
    active: {
      type: "Boolean",
      constraints: {
        presence: {
          allowEmpty: true,
        },
      },
    },
    icon: {
      type: "String",
      constraints: {
        presence: {
          allowEmpty: true,
        },
      },
    },
    type: {
      type: "Enum",
      constraints: {
        inclusion: {
          within: ["INFO", "AVAILABILITY", "MAP", "CUSTOM"],
        },
        presence: {
          allowEmpty: false,
        },
      },
      defaultValue: "CUSTOM",
    },

    startDate: {
      type: "Date",
      constraints: {},
    },

    endDate: {
      type: "Date",
      constraints: {},
    },

    conditions: {
      type: "String",
      constraints: {},
    },

    entityFilter: {
      type: "Enum",
      constraints: {
        inclusion: {
          within: ["PROPERTY", "ACCOMMODATION"],
        },
        presence: {
          allowEmpty: false,
        },
      },
      defaultValue: "PROPERTY",
    },

    tickerFilter: {
      type: "String",
      constraints: {},
    },

    text: {
      type: "String",
      constraints: {
        presence: {
          allowEmpty: false,
        },
      },
    },
    ticker: tickerValidator,
    position: {
      type: "Number",
      constraints: {
        presence: {
          allowEmpty: true,
        },
      },
    },
    label: {
      type: "String",
      constraints: {
        presence: {
          allowEmpty: false,
        },
      },
    },
    content: {
      type: "String",
      constraints: {
        presence: {
          allowEmpty: false,
        },
      },
    },
    youTubeURL: {
      type: "videoLink",
      constraints: {
        videoLink: "YouTube",
      },
    },
  },
};

export default ({ locale }) =>
  getTranslatedDefinition({ ModuleDefinition, ModuleTranslations, locale });
